import useBranchBanner from './useBranchBanner';
import type { BranchBannerProps } from './useBranchBanner';

/**
 * Assumes branch.io script is loaded
 */
const BranchBanner = (props: BranchBannerProps) => {
  const { metadata } = useBranchBanner(props);
  return (
    <>
      {metadata.map(({ name, content }) => (
        <meta
          data-automation={`deeplink-metadata-${name}`}
          key={name}
          name={`branch:deeplink:${name}`}
          content={content}
        />
      ))}
    </>
  );
};

export default BranchBanner;
